export const getFallbackCalloutStyles = (classes) => {
  const baseClasses = {};
  if (classes.calloutTargetContainer) {
    baseClasses.calloutTargetContainer = classes.calloutTargetContainer;
  }

  return baseClasses;
};
